@use "../../style/mixins" as *;
@use "../../style/variables" as *;

.select {
  position: relative;
  width: 100%;
  border-bottom: 1px solid $grey-light;
  padding: 10px 10px 4px 5px;
  margin-bottom: 1.6rem;
  font-size: 1.125rem;
  font-family: inherit;
  font-weight: 300;

  @include mobile {
    font-size: 1rem;
  }

  &:hover {
    border-bottom: 1px solid $grey;
  }

  & select {
    display: none;
  }

  & label {
    display: block;
    color: $grey-light;
    height: 1.375rem;
    cursor: pointer;


    &:hover {
      color: $grey;
    }
  }

  .dropdown {
    @include card-background;
    position: absolute;
    width: 100%;
    list-style: none;
    margin: 1px 0 2rem;
    padding: .5rem 0;
    cursor: pointer;
    z-index: 10;

    li {
      padding-left: 2rem;
      line-height: 3rem;
    }

    li:hover {
      background-color: $grey-background;
    }
  }

  .selected-option {
    width: 100%;
    height: 1.375rem;
    margin-left: .2rem;
    color: $grey;
  }
}

.selected-item-border {
  border-bottom: 1px solid $grey;
}